"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoaderIcon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const theme_1 = require("@icr-ui/theme");
exports.LoaderIcon = react_1.default.forwardRef((props, ref) => {
    const { color = theme_1.colors.primary.dark, width = 70, height = 70 } = props;
    return ((0, jsx_runtime_1.jsx)("svg", { version: "1.1", id: "L9", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", x: "0px", y: "0px", viewBox: "0 0 100 100", enableBackground: "new 0 0 0 0", xmlSpace: "preserve", ...{ width, height, ref }, children: (0, jsx_runtime_1.jsx)("path", { fill: color, d: "M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50", children: (0, jsx_runtime_1.jsx)("animateTransform", { attributeName: "transform", attributeType: "XML", type: "rotate", dur: "1s", from: "0 50 50", to: "360 50 50", repeatCount: "indefinite" }) }) }));
});
exports.LoaderIcon.displayName = 'LoaderIcon';
exports.default = exports.LoaderIcon;
//# sourceMappingURL=loader.js.map